import React, { useEffect } from 'react';

// Starting point only — this needs a review by someone qualified before it is
// relied on. It describes what the site actually does today: a Mailchimp
// mailing list and Google Analytics.
const LAST_UPDATED = 'August 1, 2026';

function Section({ title, children }) {
  return (
    <section className="mb-8">
      <h2 className="text-2xl font-bold text-wine mb-3">{title}</h2>
      <div className="text-gray-700 space-y-3">{children}</div>
    </section>
  );
}

function PrivacyPolicy() {
  useEffect(() => {
    document.title = 'Privacy Policy | Vivat Alfa Winery';
  }, []);

  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#f9f5f0' }}>
      <header className="bg-wine shadow-lg">
        <nav className="max-w-4xl mx-auto px-4 py-5">
          <a href="/" className="text-white text-2xl font-bold tracking-wider hover:text-gold transition">
            <span aria-hidden="true">←</span> Vivat Alfa Winery
          </a>
        </nav>
      </header>

      <main className="max-w-3xl mx-auto px-6 py-16">
        <h1 className="text-4xl font-bold text-wine mb-2">Privacy Policy</h1>
        <p className="text-gray-500 mb-10">Last updated: {LAST_UPDATED}</p>

        <Section title="Who we are">
          <p>
            Vivat Alfa Winery is a family-owned winery at 3612 Stump Road,
            Doylestown, PA 18902. You can reach us at (267) 614-5011.
          </p>
        </Section>

        <Section title="What we collect">
          <p>
            <strong>Mailing list.</strong> If you sign up for our mailing list,
            we collect the first name, last name and email address you enter.
            You provide these voluntarily, and only to receive our emails.
          </p>
          <p>
            <strong>Website analytics.</strong> We use Google Analytics to
            understand how the site is used — for example which pages are
            visited and roughly where visitors come from. This is collected
            through cookies and is not used to identify you personally.
          </p>
          <p>
            This website is informational. We do not sell wine online, take
            payments, or collect payment card details here.
          </p>
        </Section>

        <Section title="How we use it">
          <p>
            We use your name and email only to send news about our wines,
            events and offers. We do not sell, rent or trade your information,
            and we do not share it with anyone for their own marketing.
          </p>
        </Section>

        <Section title="Who processes it for us">
          <p>
            <strong>Mailchimp</strong> (Intuit Inc.) stores our mailing list and
            sends our emails on our behalf. Your name and email are held on
            their systems, subject to their privacy terms, and are used only to
            deliver our emails.
          </p>
          <p>
            <strong>Google Analytics</strong> (Google LLC) processes website
            usage data on our behalf.
          </p>
        </Section>

        <Section title="Unsubscribing and your choices">
          <p>
            Every email we send includes an unsubscribe link, and it takes
            effect immediately. You can also email or call us and we will remove
            you ourselves.
          </p>
          <p>
            You may ask us what information we hold about you, ask us to correct
            it, or ask us to delete it. Contact us using the details above and
            we will act on your request.
          </p>
          <p>
            You can block cookies in your browser settings. The site will still
            work normally.
          </p>
        </Section>

        <Section title="How long we keep it">
          <p>
            We keep your mailing list details until you unsubscribe or ask us to
            remove them.
          </p>
        </Section>

        <Section title="Children">
          <p>
            This site is intended for people aged 21 and over. We do not
            knowingly collect information from anyone under 21.
          </p>
        </Section>

        <Section title="Changes">
          <p>
            If we change this policy we will update the date at the top of this
            page.
          </p>
        </Section>

        <Section title="Contact">
          <p>
            Questions about this policy, or about your information? Call us on
            (267) 614-5011 or speak to us at the winery.
          </p>
        </Section>
      </main>

      <footer className="bg-gray-900 text-white text-center py-8">
        <p className="mb-4">&copy; {new Date().getFullYear()} Vivat Alfa Winery. All rights reserved.</p>
        <a href="/" className="text-gold hover:text-white transition font-bold">
          <span aria-hidden="true">←</span> Back to the website
        </a>
      </footer>
    </div>
  );
}

export default PrivacyPolicy;
